type GenerateSearchPlaceholderConfig = {
  entityType?: string;
  instantSubmit?: boolean;
  regexSupport?: boolean;
};

const withSubmitHint = ({ text, instantSubmit }: { text: string; instantSubmit?: boolean }) =>
  instantSubmit ? `${text}, or apply with Cmd/Ctrl + Enter.` : `${text}...`;

export const generateSearchPlaceholder = ({
  instantSubmit,
  regexSupport,
  entityType,
}: { entityType?: string } & GenerateSearchPlaceholderConfig): string => {
  const baseText = entityType ? `Search ${entityType}` : 'Search';
  const text = regexSupport ? `${baseText} with regex` : `${baseText} by name`;

  return withSubmitHint({
    text,
    instantSubmit,
  });
};

export const generateShortSearchPlaceholder = (params?: GenerateSearchPlaceholderConfig) => {
  const text = params?.regexSupport === true ? 'Search with regex' : 'Search';

  return withSubmitHint({
    text,
    instantSubmit: params?.instantSubmit,
  });
};
